"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMSContent = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const sms_1 = require("../../../../server/sms");
const DeletePopUpLayout_1 = require("../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../base/popup");
const ChoiceMemberTable_1 = require("./ChoiceMemberTable");
const SendSMSRegist_1 = require("./SendSMSRegist");
const SendSMSContentStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex: 1;
	position: relative;
	overflow: auto;

	.divider {
		background: var(--color-grey-c, #e6e8ed);
		align-self: stretch;
		flex-shrink: 0;
		height: 1px;
	}

	.empty-sms-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		gap: 8px;
	}

	.select-sms {
		font-size: 18px;
		font-weight: 400;
		line-height: 36px;
		letter-spacing: -0.02em;
		color: #83868A;
	}

	.sms-info {
		display: flex;
		flex-direction: column;
		gap: 8px;	
		width: 100%;
	}

	.btn-recipient-setting {
		background: var(--color-white, #ffffff);
		border-radius: 100px;
		border-style: solid;
		border-color: var(--tur, #3ab2bf);
		border-width: 1px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;

		p {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			${props => !props.$isDesktop
    ? `
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			`
    : `
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);`}
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		${props => props.$isDesktop &&
    `
			position: absolute;
			right: 24px;
			padding: 4px 18px 4px 18px;
			z-index: 1;	
			gap: 8px;
		`}

		${props => props.$isTablet &&
    `
			position: absolute;
			top: 16px;
			right: 24px;
			padding: 4px 6px 4px 6px;
			z-index: 1;	
		`}


		${props => props.$isMobile &&
    `  
			padding: 6px 10px 6px 10px;
			gap: 6px;
		`}

	}

	${props => props.$isMobile
    ? `
				gap: 12px;
				flex: 1;
			  `
    : `
				background: var(--color-white, #ffffff);
				border-radius: 10px;
				border-style: solid;
				border-color: var(--color-grey-c, #e6e8ed);
				border-width: 1px;

				${props.$isDesktop
        ? `
							min-width: 400px;
							gap: 14px;
							padding: 26px;
						`
        : `
							min-width: 270px;
							gap: 12px;
							padding: 20px;
						`}
			  `}

	span,
	.overText {
		position: relative;
		text-align: left;

		${props => props.$isDesktop
    ? `
					font-size: var(--b3-font-size, 16px);
					line-height: var(--b3-line-height, 32px);
					letter-spacing: var(--b3-letter-spacing, -0.02em);
					font-weight: var(--b3-font-weight, 400);
				  `
    : `
					font-size: 14px;
					line-height: 150%;
					letter-spacing: -0.02em;
					font-weight: 400;
				  `}
	}

	.text-grey {
		color: var(--color-grey-l, #83868a);
	}

	.sms-wrap {
		flex-direction: column;
		flex: 1;
		gap: ${props => (props.$isDesktop ? '20px' : '12px')};
	}

	.send-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isDesktop ? '12px' : '10px')};
	}

	textarea {
		&.focus {
			outline: 2px solid transparent;
			outline-offset: 2px;
			box-shadow: 0 0 5px $tur; // 흐림 효과 추가
		}

		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		width: 100%;
		resize: none;
		overflow: hidden;
		padding: 9px;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: 150%;
		font-weight: var(--b4-font-weight, 400);
	}

	.sms-title {
		height: 40px !important;
	}

	.sms-content {
		min-height: 100px;
		flex: 1;
	}

	.xmd {
		p {
			font-size: 14px;
			line-height: 20px;
			display: flex;
			justify-content: center;
		}
	}

	.message-text {
		min-height: ${props => (props.$isDesktop ? '35px' : props.$isTablet ? '25px' : '20px')};
	}

	.message-length {
		text-align: right;
		font-size: 14px;
		color: var(--color-grey-b, #7e8289);
	}

	.btn-container {
		margin: 0;
	}

	.send-type {
		span {
			font-size: ${props => (props.$isDesktop ? '14px' : '12px')};
		}
	}

	.input_send {
	}

	${props => props.$isMobile &&
    `
			.mobile-full {
				border-radius: 6px;
				p {
					justify-content: center;
				}
			}

			.btn-container {
				width: 100%;
			}
		`}

	.sms-preview-content {
		word-break: break-word;
		flex: 1;
		width: 100%;	
    	min-height: 100px;
	    border-radius: 4px;
    	border-style: solid;
    	border-color: var(--color-grey-w, #b6bac0);
    	border-width: 1px;
	    white-space: pre-wrap;
		padding: 9px;
    	text-align: left;
    	font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    	font-size: var(--b4-font-size, 14px);
    	line-height: 150%;
    	font-weight: var(--b4-font-weight, 400);
		span {
			text-align: left;
    		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    		font-size: var(--b4-font-size, 14px);
    		line-height: 150%;
    		font-weight: var(--b4-font-weight, 400);
		}
	}
`;
exports.SendSMSContent = react_1.default.memo(({ selectedId, setSelectedId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const deletePostMutation = (0, react_query_1.useMutation)(sms_1.postDeleteSendSMS);
    const [receiverMemberList, setReceiverMemberList] = (0, react_1.useState)([]);
    const [startDate, setStartDate] = (0, react_1.useState)(''); // 발송일
    const [startTime, setStartTime] = (0, react_1.useState)(''); // 발송시간
    const [title, setTitle] = (0, react_1.useState)(''); // 메시지 제목
    const [message, setMessage] = (0, react_1.useState)(''); // 발송 메시지
    const [isNormal, setIsNormal] = (0, react_1.useState)(true); // 발송 타입 (일반, 치환)
    const [status, setStatus] = (0, react_1.useState)(''); // 발송 상태 (created, sent, failed)
    // 한글 2바이트, 영문 1바이트로 계산
    const getCoolsmsByteLength = (message) => [...message].reduce((bytes, char) => bytes + (char.charCodeAt(0) <= 127 ? 1 : 2), 0);
    const messageBytes = getCoolsmsByteLength(message);
    const isSMSLength = messageBytes <= 90;
    const messageLength = isSMSLength ? `${messageBytes}/90` : "MMS";
    const { data, refetch } = (0, sms_1.useSendSMSList)({
        id: selectedId,
    });
    const { data: receiversData, refetch: receiversRefetch } = (0, sms_1.useSMSReceiversList)({
        id: selectedId,
    });
    const [fetchKey, setFetchKey] = (0, react_1.useState)(0);
    const refetchList = (0, throttle_1.default)(() => refetch(), 1000, { leading: true, trailing: false });
    const refetchReceiversList = (0, throttle_1.default)(() => receiversRefetch(), 1000, { leading: true, trailing: false });
    const cleanup = () => {
        setStartDate((0, moment_1.default)().format('YYYY-MM-DD'));
        setStartTime((0, moment_1.default)().format('HH:mm'));
        setTitle('');
        setMessage('');
        setIsNormal(true);
    };
    (0, react_1.useEffect)(() => {
        if (selectedId !== '') {
            setFetchKey((prev) => prev + 1);
            refetchReceiversList();
        }
        else
            cleanup();
    }, [selectedId]);
    (0, react_1.useEffect)(() => {
        refetchList();
    }, [fetchKey]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items } = data;
            if (items && items.length >= 1) {
                const item = items[0];
                setStartDate((0, moment_1.default)(item.send_time).format('YYYY-MM-DD'));
                setStartTime((0, moment_1.default)(item.send_time).format('HH:mm'));
                setTitle(item.title);
                setMessage(item.content);
                setStatus(item.status);
                setIsNormal(item.type === 'normal' ? true : false);
                return;
            }
        }
        !isMobile && cleanup();
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (receiversData) {
            const { receivers } = receiversData;
            if (receivers && receivers.length >= 1) {
                const simpleItems = receivers.map(receiver => ({
                    id: receiver[1],
                    data: receiver,
                }));
                setReceiverMemberList(simpleItems);
                return;
            }
        }
    }, [receiversData]);
    const previewRef = react_1.default.useRef(null);
    const [preview, setPreview] = (0, react_1.useState)(''); // 미리보기 메시지
    (0, react_1.useEffect)(() => {
        const previewTitle = title.length > 0 ? `<span style="font-weight: bold;">${title}</span>\n` : '';
        setPreview(previewTitle + message);
    }, [title, message]);
    (0, react_1.useEffect)(() => {
        if (!previewRef.current)
            return;
        if (!preview) {
            previewRef.current.innerHTML = "<span style='color: gray;'>내용 없음</span>";
            return;
        }
        const highlightedText = preview.replace(/#\{(.*?)\}/g, (match, word) => {
            return SendSMSRegist_1.substitutes.includes(word)
                ? `<span style="color: #8268d9;">${match}</span>`
                : match;
        });
        previewRef.current.innerHTML = highlightedText;
    }, [preview, SendSMSRegist_1.substitutes]);
    // (onClick) 보내기
    const handlerEdit = async () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'regist',
            id: selectedId,
        });
    };
    const handlerDelete = () => {
        const onDelete = async () => {
            const id = selectedId;
            try {
                APP.eventManager.publish('SHOW_LOADING', true);
                await deletePostMutation.mutateAsync(id);
                APP.eventManager.publish('UPDATE_SEND_SMS');
                if (selectedId === id)
                    setSelectedId(undefined);
            }
            catch (error) {
                console.error('Failed to post deletePost:', error);
                alert(error);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
                setSelectedId('');
            }
        };
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t('assignment.delteInto', { count: 1 }),
                onDelete,
            },
            width: 639,
            title: t(`sendSMS.messageDelete`),
            isFit: true,
        });
    };
    const handlerOpenMemberList = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            className: 'send-popup',
            component: ChoiceMemberTable_1.ChoiceMemberList,
            componentProps: {
                memberList: receiverMemberList,
                isNotChecked: true,
                isPopup: true,
                isNormal: isNormal,
                isRegist: false,
            },
            width: isNormal ? 580 : 730,
            title: '수신자 목록',
            isFit: true,
        });
    };
    if (selectedId === '' && !isMobile) {
        return (react_1.default.createElement(SendSMSContentStyled, { "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement("div", { className: "empty-sms-content" },
                react_1.default.createElement(common_1.Icon, { icon: "arrow_in_circle_right", size: 40 }),
                react_1.default.createElement("div", { className: "select-sms" }, t('sendSMS.selectSMS')))));
    }
    ;
    return (react_1.default.createElement(SendSMSContentStyled, { className: "send-sms-content", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
        react_1.default.createElement(common_1.Button, { className: "btn-recipient-setting", text: `수신자 (${receiverMemberList?.length > 0
                ? receiverMemberList.length.toString().padStart(2, '0')
                : '00'})명`, option: {
                buttonAfterIcon: {
                    show: true,
                    className: 'arrow-right',
                    name: 'twoarrow',
                    size: isDesktop ? 22 : 12,
                    color: Colors_1.Colors.tur,
                },
            }, onClick: handlerOpenMemberList }),
        react_1.default.createElement("div", { className: "field-global-001 sms-wrap" },
            react_1.default.createElement("div", { className: "sms-info" },
                react_1.default.createElement("div", { className: "field-short" },
                    react_1.default.createElement("p", { className: "overText text-grey" }, t('sendSMS.sendType')),
                    react_1.default.createElement("p", { className: "overText" }, t(`sendSMS.${isNormal ? 'normal' : 'substitute'}`))),
                react_1.default.createElement("div", { className: "send-wrap" },
                    react_1.default.createElement("div", { className: "field-short" },
                        react_1.default.createElement("p", { className: "overText text-grey" }, t('sendSMS.sendDate')),
                        react_1.default.createElement("p", { className: "overText" }, `${startDate}, ${startTime}`)))),
            react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "send-wrap", style: { flex: '1' } },
                react_1.default.createElement("p", { className: "overText message-text text-grey", style: { width: '100%' } }, t('sendSMS.messageContent')),
                react_1.default.createElement("div", { className: "sms-preview-content", ref: previewRef }),
                react_1.default.createElement("p", { className: "message-length" }, messageLength))),
        react_1.default.createElement("div", { className: "btn-container", style: { width: '100%' } },
            status === 'created' && (react_1.default.createElement(common_1.Button, { className: `btn_white xmd`, text: t('common.modify'), onClick: handlerEdit, styles: isTablet && {
                    buttonWrap: {
                        padding: "10px 16px",
                    },
                } })),
            react_1.default.createElement(common_1.Button, { className: `btn_default xmd`, text: t('common.delete'), onClick: handlerDelete, styles: isTablet && {
                    buttonWrap: {
                        padding: "10px 16px",
                    },
                } }))));
});
